import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreWrapFnPipe } from './wrap-fn.pipe';

@NgModule({
  declarations: [CoreWrapFnPipe],
  imports: [TranslateModule],
  exports: [CoreWrapFnPipe, TranslateModule],
})
export class CoreLayoutPipesModule {}
